import { useState, useEffect } from "react";
import api from "api";
import QuoteLineMobile from "components/QuoteLineMobile";
import QuoteMobileDetail from "components/QuoteMobileDetail";
import 'styles/rentmanmobile.css';
import { useAuth } from 'auth/AuthContext';

// version mobile de la page d'accueil : liste seule, sans barre du haut ni actions, à partir d'aujourd'hui
const RentmanMobile = () => {

    const [ quotes, setQuotes ] = useState([]);
    const [ selectedQuoteId, setSelectedQuoteId ] = useState(null); // devis ouvert dans l'écran de préparation matériel
    const { logout } = useAuth();

    useEffect(() => {
        api.get(`quotes/${Date.now()}`)
        .then(response => setQuotes(response.data));
    }, []);

    if (selectedQuoteId) {
        return (
            <QuoteMobileDetail
                quoteid={selectedQuoteId}
                onBack={() => setSelectedQuoteId(null)}
            />
        );
    }

    return (
        <div className="RentmanMobile">
            <button className="RentmanMobileLogout" onClick={logout} title="Se déconnecter">🔒</button>
            {
                quotes.map((q) =>
                    <QuoteLineMobile
                        key={q.id}
                        quoteid={q.id}
                        printCancelled={false}
                        onClick={() => setSelectedQuoteId(q.id)}
                    />
                )
            }
        </div>
    );

};

export default RentmanMobile;
